import React, { useMemo } from 'react';
import { withWindow } from '@shared/utils/withWindow';
import { useMarcomAppTelemetry } from '../../../MarcomApp.telemetry';
import { useFeatureFlagsContext } from '@shared/core/featureFlags';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { Instagram, Pinterest, Facebook, Twitter } from '@withjoy/joykit/icons';
import { StyledLinkV2 } from './FooterSocial.styles';

export const FooterSocial: React.FC = () => {
  const { wwwNavigate } = useMarcomAppTelemetry();
  const { formatToUrl } = useFeatureFlagsContext();

  const links = useMemo(
    () => [
      {
        id: 'footer2instagram',
        nodeText: 'Instagram',
        icon: (
          <Instagram
            color="white"
            size={32}
          />
        ),
        href: 'https://www.instagram.com/withjoy',
      },
      {
        id: 'footer2pinterest',
        nodeText: 'Pinterest',
        icon: (
          <Pinterest
            color="white"
            size={32}
          />
        ),
        href: 'https://www.pinterest.com/joytheapp',
      },
      {
        id: 'footer2facebook',
        nodeText: 'Facebook',
        icon: (
          <Facebook
            color="white"
            size={32}
          />
        ),
        href: 'https://www.facebook.com/joytheapp',
      },
      {
        id: 'footer2twitter',
        nodeText: 'Twitter',
        icon: (
          <Twitter
            color="white"
            size={32}
          />
        ),
        href: 'https://twitter.com/joytheapp',
      },
      {
        id: 'footer2twitterHash',
        nodeText: 'Twitter Hash Tag',
        icon: '#withjoy',
        href: 'https://twitter.com/joytheapp',
      },
    ],
    [],
  );

  const handleOnClick = useEventCallback((id: string, href: string, nodeText: string) => {
    const formattedHref = formatToUrl(href);
    wwwNavigate({ elementId: id, to: formattedHref, nodeText });
    withWindow(global => {
      global.location.href = formattedHref;
    });
  });

  return (
    <>
      {links.map(link => (
        <StyledLinkV2
          key={link.id}
          id={link.id}
          href={link.href}
          onClick={() => handleOnClick(link.id, link.href, link.nodeText)}
          typographyVariant="FeatureHead17"
        >
          {link.icon}
        </StyledLinkV2>
      ))}
    </>
  );
};
